/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from "react";
import { Container, Row, Col, Badge, Button } from "../components/ui";
import Post from "../components/common/post";
import { getEducationalPosts } from "../api";
import { Modal, ModalHeader, ModalBody } from "../components/ui";
import { Link } from "react-router-dom";
import { withRouter } from "../hooks/withRouter";
import dayjs from "dayjs";
import DateSelector from "../components/common/DatePicker/index";
import Pagination from "components/common/Pagination";
import "../../src/assets/styles/memberPosts.scss";
import { DotLoader } from "react-spinners";
import publisherStore from "../flux/publisherStore";

class MemberBlogOverview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: JSON.parse(localStorage.getItem("user")),
      session: JSON.parse(localStorage.getItem("session")),
      currentPage: 0,
      posts: [],
      publishersSelected: [],
      showModal: false,
      startDate: null,
      endDate: null,
      isClear: false,
      total: 0,
      activePage: 1,
      loading: false,
    };
  }
  isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  componentWillUnmount = () => {
    document.removeEventListener("scroll", this.trackScrolling);
  };

  clearFilters = () => {
    this.setState(
      {
        publishersSelected: [],
        currentPage: 0,
        startDate: null,
        endDate: null,
        isClear: true,
      },
      () => {
        this.fetchPosts(0);
      }
    );
  };

  selectPublisher = (event, id) => {
    this.setState({
      currentPage: 0,
    });
    if (this.state.publishersSelected.includes(id)) {
      let temp = this.state.publishersSelected;
      const index = temp.indexOf(id);
      temp.splice(index, 1);
      this.setState({ publishersSelected: temp });
    } else {
      let temp = this.state.publishersSelected;
      temp.push(id);
      this.setState({ publishersSelected: temp });
    }
    this.fetchPosts(0);
  };

  fetchPosts = async (page) => {
    const filter = {
      authorIds: this.state.publishersSelected,
      tagIds: [],
      educationOnly: false,
      contentAvailabilityId: 2,
      publishedAt: {
        from: this.state.startDate ? this.state.startDate + " 00:00:00" : null,
        to: this.state.endDate ? this.state.endDate + " 23:59:59" : null,
      },
    };
    const posts = await getEducationalPosts(filter, 7, page);
    this.setState({
      posts: posts.data.items,
      currentPage: page,
      total: posts ? posts.data.total : 0,
      activePage: 1,
    });
  };

  componentDidMount = async () => {
    this.setState({ loading: true });
    if (
      this.props.location?.state &&
      this.props.location.state.details
    ) {
      this.setState({ showModal: true, loading: false });
    }

    let user = localStorage.getItem("user");
    document.addEventListener("scroll", this.trackScrolling);
    const filter = {
      authorIds: [],
      tagIds: [],
      educationOnly: false,
      contentAvailabilityId: 2,
    };
    if (this.props.location?.state) {
      let analystId = this.props.location.state.analyst;
      filter.authorIds = analystId ? [analystId] : [];
      let temp = this.state.publishersSelected;
      temp.push(analystId);
      this.setState({ publishersSelected: temp });
    }
    const posts = await getEducationalPosts(filter, 7, 0);
    this.setState({
      posts: posts ? posts.data.items : [],
      total: posts ? posts.data.total : 0,
      loading: false,
    });
    window.scrollTo(0, 0);
  };

  datesSelected = (start) => {
    if (start[0] !== null || start[1] !== null) {
      this.setState({
        startDate:
          start[0] !== null ? dayjs(start[0]).format("YYYY-MM-DD") : null,
        endDate:
          start[1] !== null ? dayjs(start[1]).format("YYYY-MM-DD") : null,
      });
      setTimeout(() => {
        this.fetchPosts(0);
      }, 1000);
    } else {
      setTimeout(() => {
        this.setState({ startDate: null, endDate: null });
        this.fetchPosts(0);
      }, 1000);
    }
  };

  handlePageChange = async (pageNumber) => {
    this.setState({ activePage: pageNumber });
    const filter = {
      authorIds: this.state.publishersSelected,
      tagIds: [],
      educationOnly: false,
      contentAvailabilityId: 2,
      publishedAt: {
        from: this.state.startDate ? this.state.startDate + " 00:00:00" : null,
        to: this.state.endDate ? this.state.endDate + " 23:59:59" : null,
      },
    };
    const posts = await getEducationalPosts(filter, 7, pageNumber - 1);
    this.setState(
      {
        posts: posts.data.items,
      },
      () => {
        window.scrollTo(0, 0);
      }
    );
  };

  render() {
    const mobileScreen = window.screen.width < 500;
    const userDetails = this.props.location?.state?.details;
    const renewal = this.props.location?.state?.renewal;
    return this.state.loading ? (
      <div className="mainLoaderBlock">
        <DotLoader color="#36d7b7" />
        <label style={{ marginTop: 30 }}>Loading your content...</label>
      </div>
    ) : (
      <Container
        style={{
          padding: "0px",
        }}
      >
        <div
          style={{
            borderRadius: "0px",
            margin: window.screen.width > 767 ? "10px 0px 20px 0px" : {},
            paddingTop: window.screen.width > 767 ? "20px" : {},
          }}
        >
          <Row noGutters className="page-header py-4">
            <Col lg="4">
              <span
                style={{
                  marginLeft: 15,
                  position: window.screen.width > 767 ? "relative" : {},
                  left: window.screen.width > 767 ? "90px" : {},
                }}
                className="d-flex mt-1"
              >
                <DateSelector
                  selectedDates={this.datesSelected}
                  clear={this.state.isClear}
                />
                {window.screen.width < 500 && (
                  <div className="button-wrapper">
                    <Button
                      theme="accent"
                      style={{
                        borderRadius: 20,
                        padding: mobileScreen ? "10px" : {},
                        lineHeight: mobileScreen ? "16px" : {},
                        marginLeft: mobileScreen ? "15px" : {},
                      }}
                      className="cancel"
                      onClick={this.clearFilters}
                    >
                      Clear all filters
                    </Button>
                  </div>
                )}
              </span>
            </Col>
            <Col lg="8">
              <div
                style={{
                  display: mobileScreen ? "flex" : {},
                  marginLeft: mobileScreen ? "15px" : {},
                  marginBottom: mobileScreen ? "15px" : {},
                  marginTop: window.screen.width > 1000 ? "2px" : {},
                }}
                className="filters text-right"
              >
                {(publisherStore.getPublishers() || [])
                  .filter((p) => p.isHidden === false)
                  .map((publisher, idx) => (
                    <a
                      href="#"
                      key={idx}
                      className={
                        this.state.publishersSelected.includes(publisher.id)
                          ? "selected card-post__author-avatar card-post__author-avatar--small"
                          : "card-post__author-avatar card-post__author-avatar--small"
                      }
                      onClick={(e) => this.selectPublisher(e, publisher.id)}
                    >
                      <img src={publisher.avatar.small} alt={publisher.name} />
                    </a>
                  ))}
                {window.screen.width > 500 && (
                  <div className="button-wrapper">
                    <Button
                      theme="accent"
                      style={{ borderRadius: 20 }}
                      className="cancel"
                      onClick={this.clearFilters}
                    >
                      Clear all filters
                    </Button>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>
        <div
          style={{
            margin: window.screen.width > 768 ? "0% 21%" : "0% 7.5%",
            borderLeft: "1px solid #ebebeb",
            borderRight: "1px solid #ebebeb",
            padding: window.screen.width > 768 ? "0px 55px" : "0px 0px",
          }}
          id={"post-wrapper"}
        >
          {this.state.posts.map((post, idx) => (
            <>
              <Link
                to={`/analyst/${post.author.slug}`}
                className="card-post__author-avatar card-post__author-avatar--small"
                style={{
                  backgroundImage: `url('${post.author.avatar.small}')`,
                  zIndex: 10,
                  width: window.screen.width > 768 ? 65 : 40,
                  height: window.screen.width > 768 ? 65 : 40,
                  position: "absolute",
                  marginLeft: window.screen.width > 768 ? "-90px" : "-19px",
                }}
              ></Link>
              <Post key={idx} col={"12"} post={post} />
            </>
          ))}
          <label className="pagelabel">
            Page {this.state.activePage} of {Math.ceil(this.state.total / 7)}
          </label>
        </div>
        <div
          className="paginationDiv"
          style={{
            borderRight: "1px solid rgb(235, 235, 235)",
            width: window.screen.width > 768 ? "58%" : "85%",
            margin: window.screen.width > 768 ? "0% 21%" : "0% 7.5%",
          }}
        >
          <Pagination
            itemClass="page-item"
            linkClass="page-link"
            activePage={this.state.activePage}
            itemsCountPerPage={7}
            totalItemsCount={this.state.total}
            pageRangeDisplayed={window.screen.width < 500 ? 1 : 3}
            onChange={this.handlePageChange.bind(this)}
            hideDisabled={true}
          />
        </div>
        <Modal
          centered
          size="lg"
          isOpen={this.state.showModal}
          toggle={() => {
            this.setState({ showModal: false });
          }}
        >
          <ModalHeader
            style={{ borderBottom: "none", height: "10px" }}
            toggle={() => {
              this.setState({ showModal: false });
            }}
          ></ModalHeader>
          <ModalBody>
            <div style={{ textAlign: "center" }}>
              <label
                style={{
                  fontWeight: 500,
                  fontSize: "16px",
                  marginBottom: "25px",
                }}
              >
                <b style={{ color: "#f1591e", fontSize: "24px" }}>
                  Welcome {userDetails?.name}{" "}
                  <Badge
                    pill
                    className={"badge-confirm"}
                    style={{
                      borderRadius: "30px",
                      background: "#0aa60a",
                      color: "white",
                    }}
                  >
                    {" "}
                    ✔
                  </Badge>
                </b>{" "}
                <br /> <br />
                You have successfully purchased the{" "}
                <b style={{ color: "#f1591e" }}>
                  {" "}
                  {userDetails?.productId === 3
                    ? "Monthly"
                    : userDetails?.productId === 4
                    ? "Quaterly"
                    : userDetails?.productId === 5
                    ? "LifeTime"
                    : "Annual"}{" "}
                </b>
                {userDetails?.productId === 5 &&
                userDetails?.paymentMethodId === 5 ? (
                  "Product and will continue to have full access to this service for as long as you hold the NFT in the wallet you registered with.  If the NFT moves wallets, your access will be lost and you will need to re-confirm your NFT access via your Profile page."
                ) : (
                  <>
                    Product and you are set to automatically renew for your
                    convenience on
                    <b style={{ color: "#f1591e" }}>
                      {" "}
                      {renewal && dayjs(renewal).format("MMMM Do YYYY")}
                      .
                    </b>
                  </>
                )}
                <br /> <br /> Your login to the website is via{" "}
                <b style={{ color: "#f1591e" }}>
                  {userDetails?.email}
                </b>{" "}
                and the password you selected.
                <br /> <br /> Settings such as Notifications, Password,
                DisplayNames, and Billing can be found via the PROFILE at the
                Top Right of your screen.
                <br /> <br />
                Support requests can be made via the Bottom Right Support
                Button. Terms and Service of your membership can be found here{" "}
                <label
                  onClick={() => {
                    this.props.navigate("/terms&conditions");
                  }}
                  style={{
                    color: "#f1591e",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                >{`${window.location.origin}/terms&conditions`}</label>
                <br /> <br />
                <label style={{ color: "#f1591e" }}>
                  Welcome to Bitcoin Live
                </label>
              </label>
            </div>
          </ModalBody>
        </Modal>
      </Container>
    );
  }
}

export default withRouter(MemberBlogOverview);
